import {Module} from "const/Module"

export default {
  "settings": "Instellingen",
  "modules": "Modules",

  [Module.dashboard]: "Dashboard",
  [Module.company]: 'Bedrijven',
  [Module.person]: 'Personen',
  [Module.invoice]: 'Facturen',
  [Module.product]: 'Producten',

  [Module.user]: 'Mijn account',
  [Module.userMyAccount]: 'Mijn account',

  [Module.client]: 'Bedrijfsgegevens',
  [Module.clientMyAccount]: 'Bedrijfsgegevens',

  [Module.system]: 'Systeem instellingen',
  [Module.systemSettings]: 'Systeem instellingen',

  [Module.imapSync]: 'imapSync',

  [Module.invoiceDefaultSettings]: 'Algemeen',
  [Module.invoiceNumberSettings]: 'Factuurnummer',
  [Module.invoicePrintTemplateSettings]: 'Print template',
  [Module.invoiceExport]: "Exporteer facturen",

  [Module.layout]: 'Indelingen',

  [Module.addressType]: 'addressType',
  [Module.phoneNumberType]: 'phoneNumberType',
  [Module.emailAddressType]: 'emailAddressType',

  [Module.address]: 'address',
  [Module.bankAccount]: 'bankAccount',
  [Module.businessNumbers]: 'businessNumbers',
  [Module.companyContactPerson]: 'companyContactPerson',
  [Module.companyRelationCompany]: 'companyRelationCompany',
  [Module.dossier]: 'dossier',
  [Module.dossierNote]: 'dossierNote',
  [Module.emailAddress]: 'emailAddress',
  [Module.personNumbers]: 'personNumbers',
  [Module.phoneNumber]: 'phoneNumber',
}
